import { useGetMeQuery } from 'API/BaseApi';
import { IAccessControlCheckProps } from '../IAccessControlCheckProps';

export const useAccessControlCheck = (values: IAccessControlCheckProps[]) => {
  const { data } = useGetMeQuery();
  const permissions = data?.permissions ?? [];

  const checkedValues = values.map(({ allowedPermissions, requireAll = false }) => {
    return (
      allowedPermissions.length === 0 ||
      (requireAll
        ? allowedPermissions.every((p) => permissions.includes(p))
        : allowedPermissions.some((p) => permissions.includes(p)))
    );
  });
  return checkedValues;
};
